import { Col, Row } from 'react-bootstrap'
import styles from './Social.module.css'

export default function Social() {
    const img = "./assets/images/follow-us.png"
    const imgMobile = "./assets/images/follow-us-mobile.png"
    const social = {
        facebook: "./assets/images/facebook.svg",
        instagram: "./assets/images/instagram.svg",
        youtube: "./assets/images/youtube.svg",
        tiktok: "./assets/images/tiktok.svg",
        linkedin: "./assets/images/linkedin.svg"
    }

    return (
        <section>
            <Row className={`${ styles.container } m-auto align-items-center justify-content-center mt-5 text-center `}>
                <Col xs="12" sm="12" md="11" lg="11" className='p-0'>
                        <img src={img} alt='followUs' className={ `${styles.img} d-none d-md-block mt-5`}/>
                        <img src={imgMobile} alt='followUsMobile' className={ `${styles.img} d-sm-block d-md-none mt-5`}/>
                        <div className='d-flex m-auto col-6 col-lg-3 align-items-center justify-content-between mt-2 mt-md-5'>
                            <a href='https://www.facebook.com/monogroupofficial/' target='new_blank'>
                                <img src={social.facebook} className={`${ styles.iconStyle }`} alt='facebook' />
                            </a>
                            <a href='https://www.instagram.com/monoracingofficial/' target='new_blank'>
                                <img src={social.instagram} className={`${ styles.iconStyle }`} alt='instagram' />
                            </a>
                            <a href='https://www.youtube.com/@monogroup_official' target='new_blank'>
                                <img src={social.youtube} className={`${ styles.iconStyle }`} alt='youtube' />
                            </a>
                            <a href='https://www.tiktok.com/@monoracingofficial' target='new_blank'>
                            <img src={social.tiktok} className={`${ styles.iconStyle }`} alt='tiktok' />
                            </a>
                            <a href='https://www.linkedin.com/company/monogroupofficial' target='new_blank'>
                                <img src={social.linkedin} className={`${ styles.iconStyle }`} alt='linkedin' />
                            </a>
                        </div>
                </Col>
            </Row>
        </section>
    )
}